export const userText = "User subscribes to be notified when the ";
export const upgradeToProText = "Please upgrade to Directory Pro to access this feature" 
